import PropTypes from "prop-types"
import React from "react"

import Form from "src/components/Form"

const PickerSubmitError = ({ submitError }) => {
  if (!submitError) return null
  return (
    <Form.Error>
      {submitError.message}
      {submitError.link ? (
        <>
          {" "}
          <a className="text-link" href={submitError.link}>
            View existing contacts.
          </a>
        </>
      ) : null}
    </Form.Error>
  )
}

PickerSubmitError.propTypes = {
  submitError: PropTypes.shape({
    message: PropTypes.string.isRequired,
    link: PropTypes.string,
  }),
}

export default PickerSubmitError
